module.exports = __webpack_public_path__ + "img/member_edit.fc38d64e.svg";